let scroll = window.requestAnimationFrame

const mainNavLinks   = document.querySelectorAll('#desktopHeaderMainMenu > li > a')
const anchorSections = document.querySelectorAll('.main > .wp-block-group, .main > .wp-block-cover');
const elementsToShow = document.querySelectorAll( '.animate' )
const headerOffset   = 110;
const animationActionClass = 'animated'


const init = function() {
    if ( window.requestAnimationFrame ) {
        loop()
    } else {
        showAllAnimationElements()
    }
}


const loop = function() {
    watchForAnimationElements()
    watchTop()
    watchAnchors()
    scroll( loop )
}


const watchTop = function() {

    const scrollAmount = window.scrollY

    if ( scrollAmount <= 0 ) {
        document.body.classList.add('is-at-top')
    } else {
        document.body.classList.remove('is-at-top')
    }

}


const watchAnchors = function() {

    if ( anchorSections ) {

        anchorSections.forEach( anchorSection => {

            const rect = anchorSection.getBoundingClientRect()
            const anchor = anchorSection.getAttribute('id')
            const anchorSectionTop = rect.y
            const anchorSectionBottom = rect.y + anchorSection.offsetHeight

            if ( anchorSectionTop < headerOffset && anchorSectionBottom > headerOffset ) {
                mainNavLinks.forEach( navItem => {
                    
                    const link = navItem.getAttribute('href').replace('#','');
                    
                    if ( link.includes( anchor ) ) {
                        navItem.classList.add('is-current')
                    } else {
                        navItem.classList.remove('is-current')
                    }
                    
                } )
            }

        } )

    }

}


const watchForAnimationElements = function() {
    elementsToShow.forEach( ( element ) => {
        if ( isElementInViewport( element ) ) {
            if ( element.classList.contains( animationActionClass ) ) return
            element.classList.add( animationActionClass )
        }
    } )
}


const isElementInViewport = function( element ) {

    const rect = element.getBoundingClientRect()

    return (
        ( rect.top <= 0 && rect.bottom >= 0 )
        ||
        ( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
        ||
        ( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
    )

}


const showAllAnimationElements = function() {

    elementsToShow.forEach( element => { element.classList.add( animationActionClass ) } )

}


const api = {
    init: init
}

export default api;
